import { Component, ViewEncapsulation } from "@angular/core";
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '../shared/footer/footer.component';
import { TenantPublicContentService } from '../tenant/tenant-public-content.service';
import { TenantBrandingService } from '../tenant/tenant-branding.service';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FooterComponent
  ],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AboutComponent {
  content$ = this.tenantContent.content$;
  branding$ = this.tenantBranding.branding$;

  constructor(
    private tenantContent: TenantPublicContentService,
    private tenantBranding: TenantBrandingService,
  ) {}
}

